
// component events
const UPDATE_MODEL_EVENT = 'update:modelValue'
const UPDATE_PAGE_SIZE_EVENT = 'update:modelValue'
const UPDATE_DISPLAY_EVENT = 'update:display'
const UPDATE_FILES_EVENT = 'update:files'
const SELECTED_FILE = 'selectFile'
const BEFORE_UPLOAD_FILE = 'beforeUploadedFile'
const UPLOADED_FILE = 'uploadedFile'
const CLICK_EVENT = 'click'
const MENU_CLICK_EVENT = 'menuClick'
const PRIMARY_CLICK_EVENT = 'primaryClick'
const CHANGE_PAGE_SIZE_EVENT = 'changePageSize'
const CHANGE_EVENT = 'change'
const SELECTED_EVENT = 'selected'
const INPUT_EVENT = 'input'
const FOCUS_EVENT = 'focus'
const BLUR_EVENT = 'blur'

export {
  UPDATE_MODEL_EVENT,
  UPDATE_DISPLAY_EVENT,
  SELECTED_FILE,
  UPLOADED_FILE,
  BEFORE_UPLOAD_FILE,
  CLICK_EVENT,
  MENU_CLICK_EVENT,
  PRIMARY_CLICK_EVENT,
  UPDATE_PAGE_SIZE_EVENT,
  CHANGE_PAGE_SIZE_EVENT,
  CHANGE_EVENT,
  INPUT_EVENT,
  FOCUS_EVENT,
  BLUR_EVENT,
  UPDATE_FILES_EVENT,
  SELECTED_EVENT,
}
